/**
 * Initialize media bar
 * @init
 */

/**
 * Creates media bar ui
 * @createMediaBar
 */

/**
 * Adds media bar events like play, pause, etc.
 * @mediaBarEvents
 */

/**
 * Format media bar's current-time and duration-time.
 * @formatMediaBarTime
 */

/**
 * Displays current time of the current media
 * @displayCurrentTime
 */

/**
 * Displays duration time of the current media
 * @displayDuration
 */

/**
 * Handle media events (for example :- what to do when pause happens)
 * @mediaEvents
 */

/**
 * Handles volume Icons
 * @updateVolumeIcon
 */

import templates from "./template.js";
import { _$ } from "/WebInterface/new-ui/assets/js/utils/dom.js";

export default class MediaBar {
  constructor(media, parentElement = _$("body").el()) {
    this.media = media; // Media on which media bar will be applied
    this.parentElement = parentElement; // parent element of mediaBar
  }

  init = () => {
    _$(this.media).on("loadedmetadata", (e) => {
      this.createMediaBar();
      this.mediaBarEvents(e.target);
      this.mediaEvents(e.target);
      this.displayDuration(e.target);
    });
  };

  createMediaBar = () => {
    const content = _$(this.parentElement).el();

    _$("#videoPlayer").remove();
    const mediaPlayerBar = templates.mediaBarTemplate();
    content.insertAdjacentHTML("afterend", mediaPlayerBar);
  };

  mediaBarEvents = () => {
    const media = this.media;

    _$("#play").on("click", () => {
      media.paused || media.ended ? media.play() : media.pause();
    });

    _$("#videoSlider").on("input", (e) => {
      media.currentTime = e.target.value;
    });

    _$("#audioSlider").on("input", (e) => {
      media.volume = e.target.value;
    });

    _$("#videoPlayerFullscreenButton").on("click", () => {
      if (media.requestFullscreen) {
        media.requestFullscreen();
      } else if (media.webkitRequestFullscreen) {
        /* Safari */
        media.webkitRequestFullscreen();
      } else if (media.msRequestFullscreen) {
        /* IE11 */
        media.msRequestFullscreen();
      }
    });
  };

  formatMediaBarTime = (time) => {
    if (time < 60) {
      return `0:${time < 10 ? "0" + Math.floor(time) : Math.floor(time)}`;
    } else {
      const min = Math.floor(time / 60);
      const sec = Math.floor(time % 60);
      return `${min}:${sec < 10 ? "0" + sec : sec}`;
    }
  };

  displayCurrentTime = () => {
    const media = this.media;

    _$("#videoSlider").val(media.currentTime);
    _$("#currentTime").text(this.formatMediaBarTime(media.currentTime));
  };

  displayDuration = () => {
    const media = this.media;

    const mediaSlider = _$("#videoSlider");
    mediaSlider.attr("max", Math.floor(media.duration));
    mediaSlider.val(0);

    _$("#currentTime").text("0:00");
    _$("#duration").text(this.formatMediaBarTime(media.duration));
  };

  mediaEvents = () => {
    const media = this.media;

    _$(media).on("timeupdate", (e) => this.displayCurrentTime(e.target));
    _$(media).on("volumechange", (e) => {
      _$("#audioSlider").el().value = media.volume;
      this.updateVolumeIcon(media);
    });

    _$(media).on("play", () => {
      _$("#play").addClass("icon-pause");
      _$("#play").removeClass("icon-play");
    });
    _$(media).on("pause", () => {
      _$("#play").addClass("icon-play");
      _$("#play").removeClass("icon-pause");
    });
  };

  updateVolumeIcon = () => {
    const media = this.media;

    const volumeIcon = _$("#volumeIcon").el();

    if (media.volume === 0) {
      volumeIcon.className = "icon-volume-off";
    } else if (media.volume < 0.5) {
      volumeIcon.className = "icon-volume-down";
    } else {
      volumeIcon.className = "icon-volume-up";
    }
  };
}
